import { globalTheme } from 'srs.sharedcomponents/lib/esm/styles/config'
import { componentsConfig } from '../components/config'
import CustomHeader from 'srs.sharedcomponents/lib/esm/components/organisms/Header/Layout2'

const themeColor = '#002469'
const blueColor = 'rgb(14, 22, 100) !important'

function getCustomHeaderColor(customValue: string): string {
  return customValue
}

function getGlobalOrFallbackColor(
  globalValue: unknown,
  fallback: string,
): string {
  if (typeof globalValue === 'string' && globalValue) {
    return globalValue
  }
  return fallback
}

const isCustomHeader = componentsConfig.Header === CustomHeader

export const customTheme = {
  ...globalTheme,
  colors: {
    ...globalTheme?.colors,
    warningLight: 'rgba(228, 0, 43, 0.15)',
    warningLightTextColor: '#e4002b',
    menuButton: isCustomHeader
      ? getCustomHeaderColor(themeColor)
      : getGlobalOrFallbackColor(globalTheme?.colors?.menuButton, '#fff'),
    primary: isCustomHeader
      ? getCustomHeaderColor('#d3d3d3')
      : getGlobalOrFallbackColor(globalTheme?.colors?.primary, '#002469'),
    sideBarActiveTextColor: isCustomHeader
      ? getCustomHeaderColor(themeColor)
      : getGlobalOrFallbackColor(
          globalTheme?.colors?.sideBarActiveTextColor,
          '#fff',
        ),
    hoverMenuButton: isCustomHeader
      ? getCustomHeaderColor(blueColor)
      : getGlobalOrFallbackColor(globalTheme?.colors?.hoverMenuButton, '#fff'),
  },
}

export { getCustomHeaderColor, getGlobalOrFallbackColor }
